function ObserverService() {
    'ngInject';

    // Unique symbol used for unambiguous object extension.
    const handlers = Symbol('handlers');

    /**
     * @description
     * The sole purpose of this function is to turn given entity into fully adapted observer object.
     *
     * @param service Service which is meant to become observer.
     */
    this.makeObservable = (service) => {
        // If this object is already an observer, perform no further operation.
        if (service[handlers]) {
            throw new Error('Function "makeObservable" was already called on this service');
        }

        // Every observer objects must have an array of callback functions.
        service[handlers] = new Set();

        if (service.registerCallback) {
            throw new Error('Function named "registerCallback" already exists in the service');
        }
        if (service.executeCallbacks) {
            throw new Error('Function named "executeCallbacks" already exists in the service');
        }

        /**
         * Extend object with callback registration and execution function.
         * Every registered callback has to be explicitly deregistered using returned function.
         */
        service.registerCallback = registerCallbackFactory(service);
        service.executeCallbacks = executeCallbacksFactory(service);
    };

    /**
     * @description
     * Factory function for registerCallbackHandler.
     */
    function registerCallbackFactory(service) {

        /**
         * @description
         * Register callback function adding it to the set of registered handlers.
         *
         * @param handler Function which will be called back after event emission.
         * @returns function Function used for unregistering handler passed as an argument.
         */
        return (handler) => {
            service[handlers].add(handler);
            return () => service[handlers].delete(handler);
        };
    }

    /**
     * @description
     * Factory function for executeCallbackHandlers.
     */
    function executeCallbacksFactory(service) {
        /**
         * @description
         * Executes all callback functions in the order of their registration.
         *
         * @param data Custom data sent to each registered callback function.
         */
        return data => service[handlers].forEach(handler => handler(data));
    }

}

/**
 * @ngdoc service
 * @name BB.Services.service:ObserverService
 *
 * @description
 * Generic service for creating observer objects. It is meant to be used on other services, granting them observer
 * pattern utility. Observer pattern allows services to benefit from better performing communication between event
 * producers and its clients (other services or controllers for instance).
 *
 */
angular
    .module('BB')
    .service('ObserverService', ObserverService);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/utility/observer.service.js